import {
  InsuranceReceiverType,
  InsuranceTypesType,
} from "../../Insurance/types";

export type ReconcilationReportFormType = {
  endDate: any;
  startDate: any;
  insuranceType: InsuranceTypesType | null;
  receiver: InsuranceReceiverType | null;
  payer: InsuranceReceiverType | null;
  all: boolean;
};

export const defaultValues: ReconcilationReportFormType = {
   endDate: null,
  startDate: null,
  insuranceType:  null,
  receiver: null,
  payer:null,
  all:false,
};

